import React from 'react';
import { HomeIcon, CompassIcon, PlayIcon, ClockIcon, ThumbsUpIcon, MusicIcon, FilmIcon, GamepadIcon, NewspaperIcon, TrendingUpIcon, LibraryIcon, HistoryIcon, PlaySquareIcon, DownloadIcon, ShoppingBagIcon } from 'lucide-react';
export const Sidebar = ({
  isOpen
}) => {
  const menuItems = [{
    icon: <HomeIcon size={20} data-id="element-224" />,
    label: 'Home'
  }, {
    icon: <CompassIcon size={20} data-id="element-225" />,
    label: 'Explore'
  }, {
    icon: <PlayIcon size={20} data-id="element-226" />,
    label: 'Shorts'
  }, {
    icon: <div size={20} data-id="element-227" />,
    label: 'Subscriptions'
  }, {
    divider: true
  }, {
    icon: <LibraryIcon size={20} data-id="element-228" />,
    label: 'Library'
  }, {
    icon: <HistoryIcon size={20} data-id="element-229" />,
    label: 'History'
  }, {
    icon: <PlaySquareIcon size={20} data-id="element-230" />,
    label: 'Your videos'
  }, {
    icon: <div size={20} data-id="element-231" />,
    label: 'Watch later'
  }, {
    icon: <ThumbsUpIcon size={20} data-id="element-232" />,
    label: 'Liked videos'
  }, {
    icon: <DownloadIcon size={20} data-id="element-233" />,
    label: 'Downloads'
  }, {
    divider: true
  }, {
    heading: 'Explore'
  }, {
    icon: <div size={20} data-id="element-234" />,
    label: 'Trending'
  }, {
    icon: <ShoppingBagIcon size={20} data-id="element-235" />,
    label: 'Shopping'
  }, {
    icon: <MusicIcon size={20} data-id="element-236" />,
    label: 'Music'
  }, {
    icon: <FilmIcon size={20} data-id="element-237" />,
    label: 'Movies & TV'
  }, {
    icon: <GamepadIcon size={20} data-id="element-238" />,
    label: 'Gaming'
  }, {
    icon: <NewspaperIcon size={20} data-id="element-239" />,
    label: 'News'
  }];
  if (!isOpen) {
    return <div className="w-[72px] bg-[#0f0f0f] overflow-y-auto hidden md:block" data-id="element-240">
        {menuItems.filter(item => !item.divider && !item.heading).slice(0, 5).map((item, index) => <div key={index} className="flex flex-col items-center py-4 hover:bg-[#272727] cursor-pointer" data-id="element-241">
              {item.icon}
              <span className="text-[10px] mt-1" data-id="element-242">{item.label.slice(0, 5)}</span>
            </div>)}
      </div>;
  }
  return <div className={`w-[240px] bg-[#0f0f0f] overflow-y-auto hidden md:block`} data-id="element-243">
      {menuItems.map((item, index) => {
      if (item.divider) {
        return <div key={index} className="border-b border-gray-800 my-2" data-id="element-244"></div>;
      }
      if (item.heading) {
        return <h3 key={index} className="px-4 pt-2 pb-1 text-sm font-medium" data-id="element-245">
              {item.heading}
            </h3>;
      }
      return <div key={index} className="flex items-center px-4 py-2 hover:bg-[#272727] cursor-pointer rounded-lg mx-2" data-id="element-246">
            {item.icon}
            <span className="ml-5 text-sm" data-id="element-247">{item.label}</span>
          </div>;
    })}
    </div>;
};